import { createFileRoute } from "@tanstack/react-router";
import { CollectDataPage } from "@/modules/collect-data/presentation/pages/CollectDataPage";

export const Route = createFileRoute("/_authenticated/collect-data")({
  component: CollectDataPage,
});
